"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stars = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Stars = function Stars(_a) {
  var id = _a.id;
  var clipPathId = id ? "Stars__clip0__".concat(id) : 'Stars__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.025 8.47a.569.569 0 00.207.624l5.537 4.79-1.654 7.23c-.056.23.03.471.218.613l.253.174a.571.571 0 00.643 0l5.79-3.55-1.03-.93a1.966 1.966 0 01-.61-2.047l.003-.01.04-.131a1.947 1.947 0 011.715-1.394l2.132-.179.834-2.11a1.955 1.955 0 011.874-1.25h.083a1.945 1.945 0 011.832 1.258l.525 1.323 4.379-3.787a.57.57 0 00.172-.624l-.092-.29a.564.564 0 00-.505-.404l-7.342-.59L12.203.372a.563.563 0 00-.54-.37h-.299a.586.586 0 00-.586.37L7.964 7.186l-7.342.59a.564.564 0 00-.505.404l-.092.29z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    d: "M11.1 16.134a.265.265 0 01-.09-.284l.04-.132a.248.248 0 01.22-.184l3.193-.268 1.223-3.097a.254.254 0 01.255-.168h.13a.245.245 0 01.235.168l1.229 3.097 3.191.268c.103.007.191.08.22.184l.04.132a.266.266 0 01-.075.284l-2.407 2.177.739 3.265a.276.276 0 01-.095.279l-.145.084a.24.24 0 01-.28 0l-2.717-1.735-2.732 1.75a.24.24 0 01-.28 0l-.11-.078a.276.276 0 01-.095-.279l.72-3.286-2.408-2.177z",
    opacity: "0.72"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Stars = Stars;